import { useMemo } from 'react';

const PDP_MAP_ZOOM = 14;
const PDP_MAP_TYPE_CONTROL_POSITION_DESKTOP = 11;
const PDP_MAP_TYPE_CONTROL_POSITION_MOBILE = 3;
const PDP_MAP_FULLSCREEN_CONTROL_POSITION = 3;
const SRL_MAP_STREET_VIEW_CONTROL_POSITION = 9;

interface IPdpMapConfig {
  zoom: number;
  options: google.maps.MapOptions;
}

const usePdpMapConfig = (mobile: boolean): IPdpMapConfig => {
  return useMemo(
    () => ({
      zoom: PDP_MAP_ZOOM,
      options: {
        mapTypeControlOptions: {
          position: mobile
            ? PDP_MAP_TYPE_CONTROL_POSITION_MOBILE
            : PDP_MAP_TYPE_CONTROL_POSITION_DESKTOP,
        },
        fullscreenControl: !mobile,
        fullscreenControlOptions: {
          position: PDP_MAP_FULLSCREEN_CONTROL_POSITION,
        },
        streetViewControl: true,
        streetViewControlOptions: {
          position: SRL_MAP_STREET_VIEW_CONTROL_POSITION,
        },
      },
    }),
    [mobile]
  );
};

export default usePdpMapConfig;
